import { Nullable, Section } from '@/types/generic';
import { atom } from 'jotai';

export const sectionAtom = atom<Nullable<Section>>(null);
